import { useTranslation } from "react-i18next";

import { useOnlineStatus } from "../../../components/Hooks/useOnlineStatus";
import { TableTotalsFooter } from "../../../components/DataTable/TableTotals";

type DiggingLoadingSummaryTableFooterProps = {
  isLoading: boolean
  loads?: number
  tonnes?: number
}

const DiggingLoadingSummaryTableFooter: React.FC<DiggingLoadingSummaryTableFooterProps> = ({
  isLoading,
  loads,
  tonnes
}) => {
  const { t } = useTranslation("production");
  const isOnline = useOnlineStatus();
  const tonnesDisplay = !isOnline && !tonnes ? t("summary.toBeConfirmed") : tonnes;

  return (
    <TableTotalsFooter
      isLoading={isLoading}
      totals={[
        { label: t("summary.totalLoads"), value: loads },
        { label: t("summary.totalTonnes"), value: tonnesDisplay }
      ]}
    />
  )
};

export default DiggingLoadingSummaryTableFooter;
